import { registerMessages } from "../../i18n/runtime";
import { communicationsNavEn } from "./messages.en";
import { communicationsNavEs } from "./messages.es";

// Imported by the module definition, not by the lazy screens: the sidebar and the phone-number control need these before any screen loads.
registerMessages("en", communicationsNavEn);
registerMessages("es", communicationsNavEs);
